import ApplicationSerializer from './application';

// Shared so RecurringInviteOneOffSerializer can extend (not silently replace) this opt-out set.
export const RECURRING_INVITE_SERIALIZE_FALSE_ATTRS = {
  locationNames: { serialize: false },
  recurringGroupInvite: { serialize: false },
};

export default class RecurringInviteSerializer extends ApplicationSerializer {
  attrs = RECURRING_INVITE_SERIALIZE_FALSE_ATTRS;

  // Mirrors the invite serializer: the folded re-approval reason rides as top-level meta.reason
  // on a split RI create (adapterOptions.workflowReevaluationReason), never round-tripped on reads.
  serializeIntoHash(hash, _typeClass, snapshot, options) {
    const payload = this.serialize(snapshot, options);
    const adapterOptions = snapshot.adapterOptions;

    if (adapterOptions && 'workflowReevaluationReason' in adapterOptions) {
      const reason = adapterOptions.workflowReevaluationReason;
      const trimmed = typeof reason === 'string' ? reason.trim() : '';
      const meta = payload.meta ?? {};
      meta.reason = trimmed ? trimmed : null;
      payload.meta = meta;
    }

    Object.assign(hash, payload);
  }
}
